/* @flow */

import * as React from 'react'
import styled from 'styled-components'

import TopNavigation from './TopNavigation'

const AdminNavigation = ({ ...rest }) => {
  return (
    <TopNavigation createNavigationLinks={createNavigationLinks} {...rest} />
  )
}

export default AdminNavigation

const createNavigationLinks = ({
  customer,
  entity,
  onHideMobileNavigation,
  toggleSearch,
  user,
  useNewColors,
}) => {
  const navigationItems = [
    {
      key: 'paying_customers',
      link: '/admin/paying-customers',
      label: 'Paying customers',

      sub_items: [
        {
          link: '/admin/subscription-product-groups',
          label: 'Subscription product groups',
        },
        {
          link: '/admin/subscription-products',
          label: 'Subscription products',
        },
      ],
    },
    {
      key: 'users',
      link: '/admin/users',
      label: 'Users',
    },
    {
      key: 'tools',
      link: '/admin',
      label: 'Tools',

      sub_items: [
        {
          link: '/admin/imports',
          label: 'Imports',
        },
        {
          link: '/admin/shopify-tools',
          label: 'Shopify tools',
        },
        ,
        {
          link: '/admin/accounting-fixing-tools',
          label: 'Accounting fixing tools',
        },
        {
          link: '/admin/miscellaneous-tools',
          label: 'Miscellaneous Tools',
        },
      ],
    },
    {
      key: 'reports',
      link: '/admin',
      label: 'Reports',

      sub_items: [
        {
          link: '/admin/feature-flags',
          label: 'Feature flags',
        },
        {
          link: '/admin/agents',
          label: 'Agents in TRAEDE stats',
        },
        {
          link: '/admin/setting-changes',
          label: 'Setting changes',
        },
      ],
    },
    {
      key: 'exit_admin',
      link: '/',
      label: 'Exit admin',
    },
  ]

  return navigationItems
}
